export default {
  images: {
    onInsert: () => {}
  },
  // enable/disable lists
  lists: true,
  fonts: {
    color: true,
    size: true
  }
}
